import { createContext, useEffect, useState } from 'react'
import { notification } from 'antd'
import type { NotificationPlacement } from 'antd/es/notification/interface'
import { CheckCircleOutlined } from '@ant-design/icons'
import Constant from '../controller/Constant'
interface contextProps {
  isSpinning: boolean
  setIsSpinning: (value: boolean) => void
  menuSelected: number
  setMenuSelected: (value: number) => void
  showErrorApiAlert: (errorMsg: any, duration?: number) => void
  contextHolder: React.ReactElement<any, string | React.JSXElementConstructor<any>>
  progress: number
  setProgress: (value: number) => void
  screenName: string
  setScreenName: (value: string) => void
  descriptionAmount: number
  setDescriptionAmount: (value: number) => void
  isMobile: boolean
  showProcessingAlert: (value: string) => void
  showGenerateCompleted: () => void
}

export const AppContext = createContext({} as contextProps)

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSpinning, setIsSpinning] = useState<boolean>(false)
  const [menuSelected, setMenuSelected] = useState<number>(0)
  const [api, contextHolder] = notification.useNotification()
  const [screenName, setScreenName] = useState<string>('')
  const [progress, setProgress] = useState<number>(0)
  const [descriptionAmount, setDescriptionAmount] = useState<number>(1)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const showErrorApiAlert = (errorMsg: any, duration: number = 3, placement: NotificationPlacement = 'topRight') => {
    api.error({
      message: (
        <AppContext.Consumer>
          {() => `${errorMsg?.response?.data?.message ?? errorMsg?.message ?? errorMsg}`}
        </AppContext.Consumer>
      ),
      placement,
      duration: duration,
    })
  }

  const showProcessingAlert = (text: string, placement: NotificationPlacement = 'top') => {
    notification.open({
      message: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckCircleOutlined style={{ fontSize: 30, color: '#2CD003', marginRight: 20 }} />
          <div>{text}</div>
        </div>
      ),
      placement,
      style: {
        whiteSpace: 'pre-line',
        zIndex: 999,
        width: 520,
        paddingTop: 10,
        paddingBottom: 0
      },
      closeIcon: false
    })
  }

  const showGenerateCompleted = (placement: NotificationPlacement = 'top') => {
    notification.open({
      message: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckCircleOutlined style={{ fontSize: 30, color: '#2CD003', marginRight: 20 }} />
          <div>{`画像の生成が完了しました。AI画像一覧で確認してください。`}</div>
        </div>
      ),
      placement,
      style: {
        whiteSpace: 'pre-line',
        zIndex: 999,
        width: 520,
        paddingTop: 10,
        paddingBottom: 0
      },
      closeIcon: false
    })
  }

  let limitMinutes = 0
  if (screenName) {
    switch (screenName) {
      case Constant.nameScreen.txt2img:
        limitMinutes = 4 * descriptionAmount
        break
      case Constant.nameScreen.img2img:
      case Constant.nameScreen.loraHistory:
        limitMinutes = 4
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (screenName) {
      const intervalId = setInterval(() => {
        setProgress((prevProgress) => {
          let newProgress = prevProgress >= 90 ? prevProgress : prevProgress + 1
          return newProgress
        })
      }, (limitMinutes * 60 * 1000) / 90)

      if ((!isSpinning && screenName) || progress == 100) {
        console.log('ddddddd')
        setScreenName('')
        setProgress(0)
        clearInterval(intervalId)
      }
      return () => clearInterval(intervalId)
    }
  }, [screenName, isSpinning])

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setIsMobile(windowWidth <= 850)
  }, [windowWidth])

  return (
    <AppContext.Provider
      value={{
        isSpinning,
        setIsSpinning,
        menuSelected,
        setMenuSelected,
        showErrorApiAlert,
        contextHolder,
        progress,
        setProgress,
        screenName,
        setScreenName,
        descriptionAmount,
        setDescriptionAmount,
        isMobile,
        showProcessingAlert,
        showGenerateCompleted
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
